export default __webpack_public_path__ + "static/media/ins_200_men.498b02ac.jpg";